<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-11-01 15:21:55
 * @LastEditTime: 2024-11-26 15:01:52
 * @Description: 信息价查看【信息价有多个表单，通过接口跳转指定表单】
 * @Param:
 * @FilePath: \ShiMo_Mobile\src\components\processHandling\informationPriceView.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="informationPriceView">
            <HeaderNav header-title="表单预览" left-icon-name="2" right-icon-name="5" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <iframe :src="formSrc" frameborder="0"></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
import { HeaderNav } from '@/components/';
export default {
    name: 'information-price-view',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            approvalData: {},
            formSrc: '',
            formInfo: '',
            newsToken: '',
            formData: {},
            isNews: '',
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.isNews = this.$route.params.isNews;
        this.formData = this.$route.params.listData;
        this.newsToken = this.$route.params.thisToken;
        this.approvalData = this.$route.params.approvalData;
        this.formInfo = await this.getFormInfo(this.approvalData.BusinessInstanceId);
        if (this.formInfo?.app_page_code) {
            this.processingFormAddress(this.formInfo);
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取表单数据
        getFormInfo(businessInstanceId) {
            const path = `/interfaceApi/sale/contract_transfinite/get_price_page/${businessInstanceId}`;
            return this.$axios.$get(path, { defEx: true, token: this.newsToken });
        },
        // 处理表单地址
        processingFormAddress(formInfo) {
            if ((this.newsToken || '') !== '') {
                this.token = this.newsToken;
            } else {
                this.token = window.localStorage.getItem('token');
            }
            this.formSrc = '' + this.GLOBAL.FORM_BASE_URL + 'angularForm/FormView.html?FormCode=' + formInfo.app_page_code + '&';
            this.formSrc += 'frameId=' + this.formData.FormId + '&';
            this.formSrc += 'FormUseInJiYunFlow=true&';
            if (this.formInfo?.cpiid) {
                this.formSrc += 'PKValues=' + formInfo.cpiid + '&';
            }
            this.formSrc += 'IsView=true&';
            this.formSrc += 'businessInstanceId=' + this.approvalData.BusinessInstanceId + '&';
            this.formSrc += 'DeviceType=2&';
            this.formSrc += 'token=' + this.token;
        },
    },
};
</script>
<style lang="stylus" scoped>
.informationPriceView
    height: 100%
    section
        height calc(100% - 45rpx)
        overflow hidden
        iframe
            width 100%
            height 100%
</style>
